import { WalletAddressesManage } from 'BreetComponents';
import { useUsdWithdrawRequestContext } from 'BreetHooks';
import { useCallback } from 'react';

const DialogWithdrawUsdWalletAddressesManage = () => {
	const { resetWalletAddressProps, formStage } = useUsdWithdrawRequestContext();

	const onAddNewAddress = useCallback(() => {
		resetWalletAddressProps();
		formStage.navigator.goTo('add-wallet-address')();
	}, [formStage, resetWalletAddressProps]);

	return (
		<WalletAddressesManage
			onAddNewAddress={onAddNewAddress}
			onEmptyWalletAddress={formStage.navigator.goTo('withdraw-funds')}
		/>
	);
};

export default DialogWithdrawUsdWalletAddressesManage;
